const configuredApiUrl = process.env.REACT_APP_API_URL;

if (!configuredApiUrl) {
  throw new Error(
    "Missing REACT_APP_API_URL. Configure it for the current frontend environment."
  );
}

const API_URL = configuredApiUrl.replace(/\/+$/, "");

export { API_URL };